import { useCallback, useState } from 'react';
import { useQueryClient } from '@tanstack/react-query';
import { toast } from 'sonner';
import { rolesNewService } from '../services/rolesNew.service';
import type { RoleFormData } from '../types/rolesNew.types';

export function useRolesNew() {
  const queryClient = useQueryClient();
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [isGeneratingCode, setIsGeneratingCode] = useState(false);

  const createRole = useCallback(async (data: RoleFormData) => {
    if (!data.name.trim()) {
      toast.error('Vui lòng nhập tên vai trò');
      return false;
    }
    if (!data.code.trim()) {
      toast.error('Không tạo được mã vai trò');
      return false;
    }

    setIsSubmitting(true);
    try {
      await rolesNewService.createRole(data);
      await queryClient.invalidateQueries({ queryKey: ['settings', 'roles'] });
      toast.success('Đã tạo vai trò');
      return true;
    } catch (error) {
      toast.error(error instanceof Error ? error.message : 'Không thể tạo vai trò');
      return false;
    } finally {
      setIsSubmitting(false);
    }
  }, [queryClient]);

  const generateCode = useCallback(async (name: string) => {
    setIsGeneratingCode(true);
    try {
      return await rolesNewService.generateUniqueCode(name);
    } catch (error) {
      toast.error(error instanceof Error ? error.message : 'Không thể tạo mã vai trò');
      return rolesNewService.slugify(name);
    } finally {
      setIsGeneratingCode(false);
    }
  }, []);

  return {
    availableModules: rolesNewService.getAvailablePermissions(),
    templates: rolesNewService.getTemplates(),
    isLoading: false,
    isSubmitting,
    isGeneratingCode,
    createRole,
    generateCode,
  };
}
